import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

/**
 * Phase 27 — tiny redirect bridge for `/:slug/{booking|client|login}`.
 *
 * Sub-routes of a branded entry page send the user to the centralized
 * flows with a `company=<slug>` query parameter. Downstream screens can
 * read it (via the existing useSearchParams hook) and keep the branded
 * context through the funnel without us duplicating the entire
 * booking/login UI per tenant.
 */
export default function CompanyRedirect({ target }) {
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Phase 2D — Mémoriser le slug tenant pour permettre à logout() de
    // ramener l'utilisateur sur la bonne landing brandée. sessionStorage
    // (per-tab, expire à la fermeture de l'onglet) — pas de token, pas
    // d'identifiant utilisateur, juste le slug public d'URL.
    try {
      if (slug && typeof slug === "string") {
        sessionStorage.setItem("sdrive_tenant_slug", slug);
      }
    } catch { /* sessionStorage indisponible — comportement existant conservé */ }
    const url = (() => {
      switch (target) {
        case "booking": return `/request?company=${encodeURIComponent(slug)}`;
        case "client":  return `/login?company=${encodeURIComponent(slug)}&redirect=%2Fagency`;
        case "driver":  return `/login?company=${encodeURIComponent(slug)}&redirect=%2Fdriver`;
        case "login":
        default:        return `/login?company=${encodeURIComponent(slug)}`;
      }
    })();
    navigate(url, { replace: true });
  }, [slug, target, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505]">
      <div className="w-8 h-8 border-2 border-amber-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
